import { useState, useEffect, useContext } from "react";
import useGenericModal from "components/GenericModal/GenericModal-logic";
import useEditProfile from "hooks/useEditProfile";
import { AccountAdminContext } from "components/AccountAdmin/AccountAdmin-container";
import { LoggedInUserContext } from "contexts/LoggedInUser";
import { getAvailableRoles, highestUserRole } from "util/role";
import { API } from "aws-amplify";

const useAccountAdminUser = user => {
  const { modalOpen, setModalOpen } = useGenericModal();
  const [modalOption, setModalOption] = useState('');
  const { currentUserProfile, accountId, updateAccount, allAccounts, allBrands } = useContext(AccountAdminContext);
  const { loggedInUserProfile } = useContext(LoggedInUserContext);
  const [inputs, setInputs] = useState();
  const [dashboardPermission, setDashboardPermission] = useState('');
  const [sharedBrands, setSharedBrands] = useState([]);
  const [sharedAccounts, setSharedAccounts] = useState([]);
  const [dashboardBrands, setDashboardBrands] = useState([]);
  const [dashboardAccounts, setDashboardAccounts] = useState([]);
  const [initInputs, setInitInputs] = useState();
  const { handleSaveProfile, handleDeactivateProfile } = useEditProfile(accountId);
  const availableRoles = getAvailableRoles(highestUserRole(loggedInUserProfile.accounts.map(account => account.role)));

  // Whenever the user updates, update the initInputs
  useEffect(() => {
    const newInputs = {
      userName: user.name,
      userEmail: user.email,
      userPhone: user.phone,
      userRole: user.role,
      userOldPassword: "",
      userNewPassword: "",
      userConfirmPassword: ""
    };
    setInitInputs(newInputs);
  }, [user]);

  // Whenever the modal opens, update
  // inputs with the current initInputs
  useEffect(() => {
    if (modalOpen) {
      let cancelled = false;
      // get dashboard permissions for user being managed
      async function getDashboardPermission() {
        try {
          if (!user?.id) return;

          const dashboardUserPermissions = await API.get('DashboardApi', `/user/${user.id}`);
          const userDashboardBrands = dashboardUserPermissions.brandAuthorship || [];
          const userDashboardAccounts = dashboardUserPermissions.accountAuthorship || [];
          const userDashboardPermission = dashboardUserPermissions.permissions || '';

          if (!cancelled) {
            setSharedBrands(userDashboardBrands);
            setSharedAccounts(userDashboardAccounts);
            setDashboardPermission(userDashboardPermission);
          }
        } catch (error) {
          if (!cancelled) {
            console.error('Failed to fetch dashboard permissions:', error);
            // Reset to default states on error
            setSharedBrands([]);
            setSharedAccounts([]);
            setDashboardPermission('');
          }
        }
      }
      setInputs(initInputs);
      getDashboardPermission();

      return () => { cancelled = true; };
    }
  }, [modalOpen, initInputs, user.id]);

  return {
    initInputs,
    inputs,
    setInputs,
    modalOpen,
    setModalOpen,
    handleSaveProfile,
    currentUserProfile,
    accountId,
    updateAccount,
    modalOption,
    setModalOption,
    handleDeactivateProfile,
    availableRoles,
    dashboardPermission,
    setDashboardPermission,
    allAccounts,
    allBrands,
    dashboardBrands,
    setDashboardBrands,
    dashboardAccounts,
    setDashboardAccounts,
    sharedBrands,
    sharedAccounts
  };
};

export default useAccountAdminUser;
